import { TableCell } from "@mui/material"
import type { FC } from "react"

import { PALLET_COLUMN_COUNT, PALLET_COLUMN_COUNT_WITHOUT_QOH } from "../../constants"
import { formatInventoryLocation } from "../../utils"

import type { InventoryPalletGroup } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface InventoryPalletTableRowCellsProps {
  pallet: InventoryPalletGroup
  isFirstLot: boolean
  uomName: string
  showQoh?: boolean
}

export const InventoryPalletTableRowCells: FC<InventoryPalletTableRowCellsProps> = ({
  pallet,
  isFirstLot,
  uomName,
  showQoh = true,
}) =>
  isFirstLot ? (
    <>
      <TableCell>{pallet.referenceNbr}</TableCell>
      <TableCell>{formatInventoryLocation(pallet.location)}</TableCell>
      {showQoh && <TableCell className='whitespace-nowrap'>{`${formatNumber(pallet.totalQoh)} ${uomName}`}</TableCell>}
    </>
  ) : (
    <TableCell colSpan={showQoh ? PALLET_COLUMN_COUNT : PALLET_COLUMN_COUNT_WITHOUT_QOH} />
  )
